<template>
  <v-simple-table dense>
    <thead>
      <tr>
        <th>Id</th>
        <th>Modalidad</th>
        <th>Día</th>
        <th>Hora</th>
        <th>Libre</th>
        <th>Accion</th>
      </tr>
    </thead>

    <tbody>
      <tr v-if="!items || items.length === 0">
        <td colspan="4">Sin registros</td>
      </tr>

      <tr v-for="disp in items" :key="disp.disponibilidadId">
        <td>{{ disp.disponibilidadId }}</td>
        <td>{{ disp.Modalidad }}</td>
        <td>{{ disp.dia }}</td>
        <td>{{ disp.hora }}</td>
        <td>{{ disp.Libre ? "Sí" : "No" }}</td>
        <td><v-btn :loading="loading" icon small color="error" v-bind="attrs" v-on="on"
            @click="EliminarDipo(disp.disponibilidadId)"><v-icon small>mdi-delete</v-icon></v-btn></td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import DisponibilidadService from "../../services/Disponibilidad.service"

export default {
  name: "DisponibilidadDetalle",
  props: {
    items: {
      type: Array,
      required: true,
    },
    docenteId: {
      required: true,
      default: -1
    }

  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    EliminarDipo(id) {
      console.log(id, this.docenteId);
      this.loading = true;

      this.loading = true
      DisponibilidadService.Desactivar(id, this.docenteId).then((result) => {
        
        // 1. Encontrar el índice del objeto con el ID
        const indice = this.items.findIndex(objeto => objeto.disponibilidadId === id);
        console.log(indice);

        // 2. Si se encuentra el índice (no es -1), eliminarlo
        if (indice !== -1) {
          this.items.splice(indice, 1); // Elimina 1 elemento desde 'indice'
        }

        this.$toast.success('Horario eliminado');
      }).catch((err) => {
        this.$toast.error(err.response.data);
      }).finally(() => { this.loading = false });
    }
  },
}
</script>
